<template>
  <div class="his-page">
    <!-- Header -->
    <div class="page-header">
      <div class="header-left">
        <h2>流水</h2>
        <span class="header-sub" v-if="list.length">共 {{ list.length }} 条记录</span>
      </div>
      <div class="header-right" @click="showPicker = true">
        <span class="header-date">{{ formatDate(date) }}</span>
        <van-icon name="calendar-o" size="20" color="#1989fa" />
      </div>
    </div>

    <van-calendar v-model="showPicker" :min-date="minDate" :max-date="maxDate"
      :show-confirm="false" :formatter="calendarFormatter" :default-date="calDefaultDate"
      @select="onSelectDate" color="#1989fa">
      <template #title>
        <div class="cal-title-bar">
          <van-icon name="arrow-left" size="18" @click.stop="calYearShift(-1)"/>
          <span class="cal-year-text">{{ calYearText }}</span>
          <van-icon name="arrow" size="18" @click.stop="calYearShift(1)"/>
        </div>
      </template>
    </van-calendar>

    <!-- 位置墙 -->
    <div class="location-wall" v-if="locations.length">
      <div
        v-for="loc in locations"
        :key="loc"
        class="location-chip"
        :class="{ active: selectedLocation === loc }"
        @click="selectLocation(loc)"
      >{{ loc }}</div>
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      finished-text="没有更多了"
      :offset="50"
    >
      <div v-if="isEmpty" class="empty-state">
        <van-icon name="notes-o" size="48" color="#c8c9cc" />
        <p>暂无记录</p>
      </div>

      <div v-else class="timeline">
        <div v-for="item in list" :key="item.sumdate" class="timeline-item">
          <div class="timeline-card">
            <div class="card-date">{{ formatCardDate(item.sumdate) }}</div>
            <div
              class="card-content"
              v-html="item.context.replace(/\r?\n/g, '<br />')"
              @click="onContentClick"
            />
          </div>
        </div>
      </div>
    </van-list>

    <div class="safe-bottom" />
  </div>
</template>

<script>
import { DatetimePicker, List, Field, CellGroup, Popup, Icon, ImagePreview, Calendar } from "vant";

export default {
  components: {
    [List.name]: List,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Icon.name]: Icon,
    [Calendar.name]: Calendar
  },
  data() {
    return {
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2099, 11, 31),
      currentDate: new Date(),
      calDefaultDate: new Date(),
      diaryDates: [],
      showPicker: false,
      pageNum: 1,
      date: "",
      list: [],
      loading: false,
      finished: false,
      locations: [],
      selectedLocation: ""
    };
  },
  computed: {
    isEmpty() {
      return !this.loading && this.list.length === 0;
    },
    calYearText() {
      return this.calDefaultDate.getFullYear() + '年';
    }
  },
  methods: {
    formatDate(d) {
      if (!d && d !== 0) return "";
      const s = String(d);
      const y = s.substring(0, 4);
      const m = s.substring(4, 6);
      const day = s.substring(6, 8);
      return `${y}年${m}月${day}日`;
    },
    formatCardDate(d) {
      if (!d && d !== 0) return "";
      const s = String(d);
      const y = s.substring(0, 4);
      const m = s.substring(4, 6);
      const day = s.substring(6, 8);
      const weekMap = ["日", "一", "二", "三", "四", "五", "六"];
      const w = new Date(y, parseInt(m) - 1, day).getDay();
      return `${y}年${m}月${day}日 周${weekMap[w]}`;
    },
    onLoad() {
      var params = { pageNum: this.pageNum++, date: this.date };
      if (this.selectedLocation) params.location = this.selectedLocation;
      this.$https
        .fetchPost("/diary/page", params)
        .then(result => {
          var data = result.data;
          for (var index in data.list) {
            this.list.push(data.list[index]);
          }
          this.loading = false;
          if (data.pageNumber >= data.totalPage) {
            this.finished = true;
          }
        });
    },
    onContentClick(e) {
      if (e.target.tagName === 'IMG') {
        var original = e.target.getAttribute('data-original');
        var src = original || e.target.src;
        if (src) ImagePreview([src]);
      }
    },
    processThumbnails() {
      var self = this;
      this.$nextTick(function () {
        var imgs = self.$el.querySelectorAll('.card-content img');
        for (var i = 0; i < imgs.length; i++) {
          (function (img) {
            if (img.getAttribute('data-processed')) return;
            img.setAttribute('data-processed', '1');
            var src = img.src;
            if (src.indexOf('qywx.lajiing.top') < 0) return;
            img.setAttribute('data-original', src);
            var thumb = src.replace(/\.jpg/i, '_thumb.jpg').replace(/\.png/i, '_thumb.jpg');
            var fallback = false;
            img.onerror = function () {
              if (fallback) { img.onerror = null; return; }
              fallback = true;
              img.src = src;
            };
            img.onload = function () { img.onerror = null; };
            img.src = thumb;
          })(imgs[i]);
        }
        // 视频添加 poster 缩略图
        var videos = self.$el.querySelectorAll('.card-content video');
        for (var j = 0; j < videos.length; j++) {
          (function (vid) {
            if (vid.getAttribute('data-poster-set')) return;
            vid.setAttribute('data-poster-set', '1');
            var src = vid.src || (vid.querySelector('source') && vid.querySelector('source').src);
            if (src && src.indexOf('qywx.lajiing.top') >= 0) {
              vid.setAttribute('poster', src.replace(/\.mp4/i, '_thumb.jpg'));
            }
          })(videos[j]);
        }
      });
    },
    fetchLocations() {
      var self = this;
      this.$https.fetchPost("/diary/locations", {}).then(function(result) {
        var data = result.data || [];
        self.locations = data.map(function(r) { return r.location; });
      });
    },
    selectLocation(loc) {
      if (this.selectedLocation === loc) {
        this.selectedLocation = "";
      } else {
        this.selectedLocation = loc;
      }
      this.pageNum = 1;
      this.finished = false;
      this.list = [];
      this.loading = true;
      var params = { pageNum: this.pageNum++, date: this.date };
      if (this.selectedLocation) params.location = this.selectedLocation;
      var self = this;
      this.$https.fetchPost("/diary/page", params).then(function(result) {
        var data = result.data;
        self.list = data.list || [];
        self.loading = false;
        if (data.pageNumber >= data.totalPage) self.finished = true;
      });
    },
    fetchDiaryDates() {
      var self = this;
      this.$https.fetchPost("/diary/dates", {}).then(function(result) {
        var data = result.data || [];
        self.diaryDates = data.map(function(r) { return String(r); });
      }).catch(function() {
        // fallback: load from page data on first load
      });
    },
    calendarFormatter(day) {
      var d = day.date;
      var y = d.getFullYear();
      var m = (d.getMonth() + 1 < 10 ? "0" : "") + (d.getMonth() + 1);
      var dayStr = (d.getDate() < 10 ? "0" : "") + d.getDate();
      var key = y + m + dayStr;
      if (this.diaryDates.indexOf(key) >= 0) {
        day.bottomInfo = "●";
      }
      return day;
    },
    calYearShift(n) {
      var d = new Date(this.calDefaultDate);
      d.setFullYear(d.getFullYear() + n);
      if (d < this.minDate) d = new Date(this.minDate);
      if (d > this.maxDate) d = new Date(this.maxDate);
      this.calDefaultDate = d;
    },
    onSelectDate(date) {
      this.showPicker = false;
      this.onLoadData(date);
    },
    onLoadData(date) {
      this.pageNum = 1;
      this.finished = false;
      this.list = [];
      var year = date.getFullYear();
      var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.date = year + "" + month + day;
      var params = { pageNum: this.pageNum++, date: this.date };
      if (this.selectedLocation) params.location = this.selectedLocation;
      this.$https
        .fetchPost("/diary/page", params)
        .then(result => {
          var data = result.data;
          this.list = data.list || [];
          this.loading = false;
          if (data.pageNumber >= data.totalPage) this.finished = true;
        })
        .catch(error => {
          console.dir(error);
          this.loading = false;
        });
    }
  },
  mounted() {
    var q = this.$route.query.date;
    if (q) {
      this.date = q;
      var y = parseInt(q.substring(0, 4));
      var m = parseInt(q.substring(4, 6)) - 1;
      var d = parseInt(q.substring(6, 8));
      this.currentDate = new Date(y, m, d);
      this.calDefaultDate = new Date(y, m, d);
    } else {
      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
      var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      this.date = year + "" + month + day;
    }
    this.fetchDiaryDates();
    this.fetchLocations();
  },
  updated() {
    this.processThumbnails();
  }
};
</script>

<style lang="less" scoped>
.his-page {
  min-height: 100vh;
  background: #f2f2f7;
}

.page-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 12px;
  background: rgba(242,242,247,.72);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);

  .header-left h2 {
    margin: 0 0 4px;
    font-size: 22px;
    font-weight: 700;
    color: #323233;
  }
  .header-sub {
    font-size: 13px;
    color: #999;
  }
  .header-right {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 20px;
    background: #f0f5ff;
  }
  .header-date {
    font-size: 13px;
    color: #1989fa;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.location-wall {
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px 10px;
  gap: 8px;

  .location-chip {
    flex-shrink: 0;
    padding: 6px 16px;
    border-radius: 100px;
    font-size: 14px;
    font-weight: 500;
    color: #3c3c43;
    background: rgba(60,60,67,0.06);
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;
    &:active { transform: scale(0.96); }
    &.active {
      color: #fff;
      background: #007aff;
    }
  }
}

.timeline {
  padding: 16px 16px 0;

  .timeline-item {
    margin-bottom: 16px;
  }
  .timeline-card {
    background: rgba(255,255,255,.72);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border-radius: 10px;
    padding: 14px 16px;

    .card-date {
      font-size: 12px;
      color: #1989fa;
      font-weight: 600;
      margin-bottom: 8px;
    }
    .card-content {
      font-size: 15px;
      color: #323233;
      line-height: 1.6;
      word-break: break-all;
      ::v-deep img {
        max-width: 100%;
        border-radius: 6px;
        cursor: pointer;
        margin: 4px 0;
      }
    }
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  p {
    margin-top: 12px;
    color: #c8c9cc;
    font-size: 14px;
  }
}

.safe-bottom {
  height: 20px;
}
.his-page .cal-title-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 4px 0;
}
.cal-year-text {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  min-width: 80px;
  text-align: center;
}
::v-deep .van-calendar__bottom-info {
  color: #1989fa !important;
  font-size: 14px;
  font-weight: bold;
  margin-top: 0;
}
</style>
